import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Maximize4Arrows from '@/images/Maximize4Arrows.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkIsAvatarOrAvatarGroup, checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import { useAnalytics } from '@/services/analytics';
import { ElementType, GroupElementType } from 'polotno/model/group-model';
import { ImageElementType } from 'polotno/model/image-model';
import { VideoElementType } from 'polotno/model/video-model';
import { fitToPageElement } from '../../actions/FitToPage';

interface Props {
    closeMenu: () => void;
}

export const FitToPageMenuItem = ({ closeMenu }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElement = store.selectedElements[0];
    const mixpanel = useAnalytics();

    const canFitToPage =
        checkPolotnoType(selectedElement, [polotnoTypes.Image, polotnoTypes.Svg, polotnoTypes.Video, polotnoTypes.Avatar]) ||
        checkIsAvatarOrAvatarGroup(selectedElement);
    if (!canFitToPage) {
        return null;
    }

    const handleClick = async () => {
        closeMenu();

        if (selectedElement.type !== polotnoTypes.Group) {
            return fitToPageElement(selectedElement as ImageElementType | VideoElementType);
        }

        if (selectedElement.type === polotnoTypes.Group) {
            const avatarElement = selectedElement.children.find((child: ElementType) => checkPolotnoType(child, polotnoTypes.Avatar));
            if (!avatarElement) {
                return;
            }

            const modifiedElement = await fitToPageElement(avatarElement as ImageElementType | VideoElementType);
            (selectedElement as GroupElementType).children.forEach((child: ElementType) => {
                child.set({
                    x: modifiedElement.x,
                    y: modifiedElement.y,
                    width: modifiedElement.width,
                    height: modifiedElement.height,
                });
            });
        }

        mixpanel?.track('fit-to-page', {
            from: 'pop-over-menu',
            'element-type': selectedElement.type,
            event: 'click',
        });
    };

    return <MenuItemIcon onClick={handleClick} src={Maximize4Arrows} text="Fit to page" />;
};
